import Vue from 'vue';

export function useHttp() {

  return Vue.prototype.$http;
}
